<template>
    <div class="attachFileToApplicant">
        <p class="attachFileToApplicant__title">{{ labels.attachFileLabel }}</p>
        <div class="attachFileToApplicant__body">
            <button type="button" class="btn btn-success mt-2 d-flex align-items-center gap-1 addFileBtn"
                    @click="addFile">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.375 7.37573L8 10L10.625 7.37573" stroke="white" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 3V9.99816" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path
                            d="M13.5 10V13.5C13.5 13.6326 13.4473 13.7598 13.3536 13.8536C13.2598 13.9473 13.1326 14 13 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8536C2.55268 13.7598 2.5 13.5 2.5 13.5V10"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ labels.attachFile }}
            </button>
            <ul class="attachFileToApplicant__body-fileList mt-2" ref="fileList"></ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FileUploader',
    props: {
        formId: {
            type: String,
            required: true,
        },
        labels: {
            type: Object,
            default: () => ({
                attachFileLabel: 'Attach file',
                attachFile: 'Attach file',
            }),
        },
    },
    data() {
        return {
            externalFiles: [],
        };
    },
    methods: {
        addFile() {
            const input = document.createElement('input');
            input.type = 'file';
            input.name = 'commentFile[]';
            input.style.display = 'none';

            document.body.appendChild(input);
            this.externalFiles.push(input);

            input.addEventListener('change', (event) => {
                const file = event.target.files[0];
                if (!file) return;

                const li = document.createElement('li');
                li.classList.add('attachFileToApplicant__body-fileList__item');

                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.textContent = file.name;
                link.download = file.name;
                link.style.cursor = 'pointer';

                li.appendChild(link);

                const removeBtn = document.createElement('button');
                removeBtn.type = 'button';
                removeBtn.classList.add('btn', 'btn-remove');
                removeBtn.innerHTML = `
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_110_1574)">
                        <path d="M8.00005 15.4981C11.9765 15.4981 15.2 12.2746 15.2 8.29814C15.2 4.32169 11.9765 1.09814 8.00005 1.09814C4.0236 1.09814 0.800049 4.32169 0.800049 8.29814C0.800049 12.2746 4.0236 15.4981 8.00005 15.4981Z" fill="#007A40"/>
                        <path d="M10.4001 5.89819L5.6001 10.6982" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.6001 5.89819L10.4001 10.6982" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_110_1574">
                            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                        </clipPath>
                    </defs>
                </svg>
            `;
                li.appendChild(removeBtn);

                removeBtn.addEventListener('click', () => {
                    input.remove();
                    this.externalFiles = this.externalFiles.filter(f => f !== input);
                    li.remove();
                });

                this.$refs.fileList.appendChild(li);
            });

            input.click();
        },
    },
    mounted() {
        const form = document.getElementById(this.formId);
        if (form) {
            form.addEventListener('submit', () => {
                this.externalFiles.forEach(input => form.appendChild(input));
            });
        }
    },
};
</script>
